import { observable, action, computed } from "mobx";
import { sortBy } from "lodash";
import axios from "axios";

const api = {
  get: (uri, page, city, state) => {
    return axios
      .get(
        `${process.env.REACT_APP_API_HOST}/api/public/merchants/${process.env.REACT_APP_MERCHANT_ID}/recent.json`,
        {
          params: { page: page, limit: 10, city: city, state: state },
        },
      )
      .then((response) => {
        return response.data;
      });
  },

  getHeaderStats: () => {
    return axios
      .get(
        `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${process.env.REACT_APP_MERCHANT_ID}.json?widget=corp_header`,
      )
      .then((response) => {
        return response.data;
      });
  },
};

class MerchantStore {
  @observable reviews;
  @observable merchant;
  @observable headerStats;

  constructor() {
    this.reviews = [];
    this.merchant = {
      name: "",
      surveyUrl: "",
      averageRating: 0,
      numRatings: 0,
      numReviews: 0,
      lastPage: true,
    };
    this.headerStats = {
      name: "",
      surveyUrl: "",
      averageRating: 0,
      numRatings: 0,
      numReviews: 0,
    };
  }

  getReviews(id, page, city, state) {
    return api.get(`merchants/${id}.json`, page, city, state).then((json) => {
      var promise = new Promise((resolve, reject) => {
        this.setData(json);
        resolve();
      });
      return promise;
    });
  }

  @computed get sortedReviews() {
    return sortBy(this.reviews, (review) => review.createdAt);
  }

  @action setData(json) {
    const url = json.merchant.surveyUrl;
    this.merchant = Object.assign({}, json.merchant, { surveyUrl: url });
    this.reviews = this.reviews.concat(json.reviews);
  }

  getHeaderStats() {
    return api.getHeaderStats().then((json) => {
      this.headerStats = Object.assign({}, json.merchant);
    });
  }
}

const store = new MerchantStore();

export default store;



// WEBPACK FOOTER //
// ./src/store.js